import { Badge, Box } from '@mantine/core';
import { useMemo } from 'react';
import classes from './Tags.module.css';

export type BNTagsProps = {
  tags: string[] | null;
};

export const BNTags = ({ tags }: BNTagsProps) => {
  const filteredTags = useMemo(() => tags?.filter((tag) => !tag.startsWith('RP_')) ?? [], [tags]); // Explanation: TKTEdge / RevPro use "RP_####" to segment their clients, but we don't want to show this to the end user
  const sortedTags = useMemo(() => filteredTags.sort((a, b) => a.localeCompare(b)), [filteredTags]);
  const colorizedTags = useMemo(() => sortedTags.map((tag) => ({ tag, color: 'gray' })), [sortedTags]);
  return (
    <Box>
      {colorizedTags.map((tag) => (
        <Badge key={tag.tag} radius="xs" py="sm" px="xs" mr={4} variant="outline" bg="var(--colors-paperHover)" className={classes.tagBadge}>
          {tag.tag}
        </Badge>
      ))}
    </Box>
  );
};
